<template>
    <div class="parent" v-if="falgCookies">
        <div class="logocookies">
            <img src="https://gthpdf.fra1.digitaloceanspaces.com/logo-footer.e772d696.png" title='logo footer gthconsult' alt="logo" />
        </div>
        <div class="letter">
            Nous utilisons des cookies pour fournir les fonctionnalités nécessaires du site Web, améliorer votre expérience et analyser notre trafic. En utilisant notre site Web, vous acceptez notre politique de confidentialité et notre politique en matière de cookies - 
            <a href="politique-de-confidentialite">Politique de cookies</a>.
        </div>
        <div class="condition">
            <input type="button" value="Tout accepter" @click="accepterCookies()" class="btn-accept"/>
            <input type="button" value="Fermer" @click="notAccepterCookies()" class="btn-close"/>
        </div>
    </div>
</template>

<script>
import { useCookies } from "vue3-cookies";

export default {
    name: "CookiesHome",
    data() {
        return {
            falgCookies: true,
        };
    },
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    methods: {
        accepterCookies() {
            this.cookies.set("accepteCookies", true, '90d');
            this.falgCookies = false;
        },
        notAccepterCookies() {
            this.cookies.set("accepteCookies", false, '90d');
            this.falgCookies = false;
        }
    }
}
</script>

<style scoped>
.parent {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-height: 120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: linear-gradient(90deg, rgba(50,150,4,0.85), rgba(0,207,255,0.85));
    padding: 15px 30px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0 -4px 15px rgba(0,0,0,0.3);
    color: white;
    z-index: 1000;
    font-family: Cairo, Verdana, Tahoma, Arial;
}

.logocookies {
    flex: 0 0 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logocookies img {
    max-height: 60px;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.logocookies img:hover {
    transform: scale(1.1);
}

.letter {
    flex: 1;
    padding: 0 20px;
    font-size: 15px;
    line-height: 1.5;
    color: #f0f0f0;
}

.letter a {
    color: #ffffff;
    font-weight: 600;
    text-decoration: underline;
    transition: color 0.3s ease;
}

.letter a:hover {
    color: #00CFFF;
}

.condition {
    flex: 0 0 140px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.condition input {
    padding: 8px 10px;
    border-radius: 6px;
    border: 2px solid white;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-accept {
    background-color: #1a73e8;
    color: white;
}

.btn-accept:hover {
    background-color: #0b4da0;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.btn-close {
    background-color: rgba(224, 64, 64, 0.8);
    color: white;
}

.btn-close:hover {
    background-color: #e03f3f;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

/* Responsive */
@media screen and (max-width: 768px) {
    .parent {
        flex-direction: column;
        align-items: flex-start;
        max-height: unset;
    }
    .letter {
        padding: 10px 0;
        font-size: 14px;
    }
    .condition {
        flex-direction: row;
        width: 100%;
        gap: 10px;
    }
    .condition input {
        flex: 1;
    }
    .logocookies {
        margin-bottom: 10px;
    }
}
</style>
